import LogoMark from './LogoMark';
import { scrollToId } from './scroll';

export default function Footer() {
    return (
        <footer className="relative z-10 border-t border-white/[0.08] bg-ink py-10" data-testid="footer">
            <div className="mx-auto flex max-w-[1300px] flex-col items-center justify-between gap-6 px-6 md:flex-row">
                <button data-testid="footer-logo" onClick={() => scrollToId('top')} className="flex items-center gap-3">
                    <LogoMark size={26} />
                    <span className="font-mono text-[10px] tracking-[0.28em] text-mist">
                        UJJWAL PRAVEEN
                    </span>
                </button>
                <p className="font-mono text-[10px] tracking-[0.2em] text-mist/50">
                    CURIOSITY → KNOWLEDGE → IMPLEMENTATION
                </p>
                <p className="font-mono text-[10px] tracking-[0.2em] text-mist/50">
                    © {new Date().getFullYear()} · SKYLINE UNDER CONSTRUCTION
                </p>
            </div>
        </footer>
    );
}
